class TaxIdPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'tax_id.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'tax_id._m';

    // Can access removed Tax IDs
    static ACCESS_REMOVED = 'tax_id.access.removed';

    // Can initiate sync
    static SYNC = 'tax_id.sync';

    // Can add new Tax ID
    static CREATE = 'tax_id.create';

    // Can remove Tax ID
    static REMOVE = 'tax_id.remove';
}

export default TaxIdPermission;
